import React, { useEffect, useState } from "react";
import { Link } from "gatsby"
import { PageLinks } from "../../common/page-links";
import ImageModule from "../../modules/image_module";

import _ from "lodash";

const GuidesCard = ({ item, imagename }) => {

    const ImageRenderList = ({ item, imagename }) => {
        let processedImages = JSON.stringify({});
        if (item?.imagetransforms?.image_Transforms) {
            processedImages = item?.imagetransforms?.image_Transforms;
        }

        return (
            <ImageModule ImageSrc={item.image} title={item.title} altText={item.title} imagetransforms={processedImages} ggfx_results={item?.ggfx_results}  renderer="srcSet" imagename={imagename} strapi_id={item.id} />
        )
    }

    //console.log("guides_categories", item.guides_categories)


    return (
        <>

            <div className="card-wrap">
                <div className="card-img">
                    <Link to={`/${PageLinks.guides_resources}/${item.slug}/`}>
                        <ImageRenderList item={item} imagename={imagename} />
                    </Link>
                </div>

                <div className="card-text">
                    {/* {item.guides_categories?.length > 0 && <span className="guide-category">{item.guides_categories.map(item => item.category_name).join(', ')}</span>} */}
                    <h3><Link to={`/${PageLinks.guides_resources}/${item.slug}/`}>{item.title}</Link></h3>
                </div>
            </div>

        </>
    );
};
export default GuidesCard;
